import {WithDebugInfo} from '../../utils/withDebugInfo/withDebugInfo';

export enum FileStatus {
  Ready = 'Ready',
  InProgress = 'InProgress',
  Failed = 'Failed',
  Unknown = 'Unknown',
  Missing = 'Missing',
}

export type CheckStatusResult<T = unknown> = WithDebugInfo<{status: FileStatus}, {originalStatus: string; response: T}>;
